import ReturnClassPicker from "@CheckOrder/features/classPicker/components/ReturnClassPicker";
import SingleClassPicker from "@CheckOrder/features/classPicker/components/SingleClassPicker";
import React from "react";

interface PassengerClassPickerProps {
    isReturn: boolean,
    passengerId: number,
}

function PassengerClassPicker({isReturn, passengerId}: PassengerClassPickerProps) {
    if (isReturn) {
        return (
            <ReturnClassPicker
                passengerId={passengerId}
            />
        )
    }

    return (
        <SingleClassPicker
            passengerId={passengerId}
        />
    )
}

export default PassengerClassPicker